<div class="payment-invalid-page" [ngStyle]="backgroundImageUrl ? {'background-image':'url(' + backgroundImageUrl + ')'} : {}">
  <div class="payment-invalid-card">
    <img *ngIf="logoImageUrl" class="payment-invalid-logo" [src]="logoImageUrl" alt="Logo"/>

    <div class="payment-invalid-message">
      <div *ngIf="currentObject.IsCompleted">
        <h4 [ngStyle]="headingTextStyle">{{ 'paymentRequestUrlInvalid.paymentIsCompletedTitle' | translate }}</h4>
        <p [ngStyle]="bodyTextStyle">{{ 'paymentRequestUrlInvalid.paymentIsCompletedText' | translate }}</p>
      </div>

      <div *ngIf="!currentObject.IsCompleted && currentObject.IsExpired">
        <h4 [ngStyle]="headingTextStyle">{{ 'paymentRequestUrlInvalid.paymentIsExpiredTitle' | translate }}</h4>
        <p [ngStyle]="bodyTextStyle">{{ 'paymentRequestUrlInvalid.paymentIsExpiredText' | translate }}</p>
        <p [ngStyle]="bodyTextStyle">{{ 'paymentRequestUrlInvalid.paymentSupplierText' | translate: currentObject }}</p>
      </div>

      <div *ngIf="!currentObject.IsCompleted && !currentObject.IsExpired">
        <h4 [ngStyle]="headingTextStyle">{{ 'paymentRequestUrlInvalid.paymentIsInvalidTitle' | translate }}</h4>
        <p [ngStyle]="bodyTextStyle">{{ 'paymentRequestUrlInvalid.paymentIsInvalidText' | translate }}</p>
        <p [ngStyle]="bodyTextStyle">{{ 'paymentRequestUrlInvalid.paymentSupplierText' | translate: currentObject }}</p>
      </div>
    </div>
  </div>
</div>
